import React, { useState} from "react";
import { Link } from "react-router-dom";

import EditStateModalWithForm from "./EditStateModalWithForm";
import { Table, Spin, Button } from "antd";;

const { Column } = Table;

const CountryStateTable = ({
  countryStateData,
  onEditClick,
  loading,
}) => {
  const [selectedState, setSelectedState] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [stateName, setStateName] = useState();
  const [trumpValue, setTrumpValue] = useState(null);
  const [bidenValue, setBidenValue] = useState(null);

  const onEditHandle = (singleState) => {
    console.log(singleState)
    if (singleState) {
      setStateName(singleState.name);
      setTrumpValue(singleState.trum);
      setBidenValue(singleState.biden)
    }
    setSelectedState(singleState);
    setShowModal(true);
  }

  const updateState = (values) => {
    console.log("=========== values ========>>>>>", values);
  }

  return (
    <Spin spinning={loading}>
      <div
        className="latest-article-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <h1 style={{ textIndent: 50 }}>Edit US States </h1>
        <Button> <Link to="/add-state"> ADD STATE </Link></Button>
      </div>
      <Table dataSource={countryStateData} rowClassName="table-row-light">
        <Column
          title="State"
          dataIndex="name"
          key="name"
          width={100}
        />
        <Column
          title="BIDEN"
          dataIndex="biden"
          key="biden"
          width={100}
        />
        <Column
          title="TRUMP"
          key="trump"
          dataIndex="trump"
          width={100}
          render={(text, record) => (
            <div
              style={{background: parseInt(text) > 50 ? "red" : "green"}}
            >
              {text}
            </div>
          )}
        />
        <Column
          title="Action"
          key="name"
          width={200}
          render={(text, record) => (
            <span>
              <a
                onClick={() => onEditHandle(record)}
                style={{ marginRight: 16 }}
              >
                Edit
              </a>
            </span>
          )}
        />
      </Table>
      {showModal && (
        <EditStateModalWithForm
          visible={showModal}
          data={selectedState}
          onCancel={() => setShowModal(false)}
          handleOk={updateState}
        />
      )}
    </Spin>
  );
};

export default CountryStateTable;
